import React from 'react';
import { Link } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import fwopening from './img/FloatyWords/fwopening.png';
import fwoptions from './img/FloatyWords/fwoptions.png';
import fwaction from './img/FloatyWords/fwaction.png';
import fwactiontwo from './img/FloatyWords/fwactiontwo.png';
import appstorebadge from './img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg';


export const FloatyWords = ({}) => {



	return (
		<div className="container-fluid appdesc">
<div className="row padrow">
 <div className="col-md-4 col-lg-8">
			 <h2>Floaty Words</h2>
 </div>
 <div className="col-md-4 col-lg-2">
 <div className="badgecontainer">
	  	<a href='https://apps.apple.com/app/id1542107370'><img src={ appstorebadge } alt="Get in on App Store Badge" className="applebadge img-responsive d-block mx-auto badge"/></a>
</div>
 </div>
 <div className="col-md-4 col-lg-2">

 </div>

 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12 centervideo">
	<iframe width="560" height="315" src="https://www.youtube.com/embed/bCFR1uUqjFo" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
 </div>
 </div>
	<div className="row padrow">
	<div className="col-md-12 col-lg-12 youtube">

	<a href='https://www.youtube.com/channel/UC4eN-brmGnxMLAYw3N5tA_g?view_as=subscriber?sub_confirmation=1'><b>Subscribe to YouTube Channel!</b>

	</a>
 </div>
 </div>

<div className="row padrow">
<div className="col-md-12 col-lg-12">
			Four little pictures are on the screen.  Push the slider and they float around.  Press or drag the word and the word is said and displayed on screen.
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src={ fwopening } alt="Opening screen of Floaty Words Application" className="appimage img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>
 <div className="row padrow">
<div className="col-md-12 col-lg-12">
			This premium version offers seven educational options, allowing your darling to learn by category.
			 </div>
 </div>
 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
			 <img src= {fwoptions } alt="Opening screen of Floaty Words Application" className="appimage img-responsive img-thumbnail d-block mx-auto"/>
</div>

 </div>
			 <div className="row padrow">
			 <div className="col-md-12 col-lg-12">
			 The speed of the floaty words is controlled through a timer at the bottom, and the refresh button randomly changes the pictures.
 </div>
 </div>
 <div className="row padrow">
			 <div className="col-md-6 col-lg-6 text-center">


	<img src={ fwaction }alt="FloatyWords screen shot" className="appimage img-responsive img-thumbnail d-block mx-auto timerpic"/>
				</div>
	<div className="col-md-6 col-lg-6 text-center">

	 <img src={ fwactiontwo } alt="FloatyWords screen shot" className="appimage img-responsive img-thumbnail d-block mx-auto timerpic"/>
				</div>
			 </div>


			 <div className="row padrow">
 <div className="col-md-12 col-lg-12">
 Please let us know if you experience any issues are have any suggstions at our feedback form <Link to="/feedback" >
 here
 </Link>.  Please note this application was designed primarily for phones as that is what we parents have handy.</div>
 </div>


</div>

			)


}
